// extracted by mini-css-extract-plugin
export default {"tripLink":"style_tripLink__VHkNI"};